import StaffManagementTableFilter from "./staff-management-table-filter";
import StaffAttendanceTableFilter from "./staff-attendance-table-filter";
import StaffAuditLogTableFilter from "./staff-audit-log-table-filter";


const StaffManagementFilters = {
    Table: StaffManagementTableFilter,
    AttendanceTable: StaffAttendanceTableFilter,
    AuditLogTable: StaffAuditLogTableFilter,
};

export default StaffManagementFilters;
